import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router-dom'
import { isLoaded, isEmpty } from 'react-redux-firebase'
import { ToastContainer } from 'react-toastify'
import { useWindowSize } from 'react-use'
import PrivateRoute from './routes/PrivateRoute'
import routes from './routes/allRoutes'
import Navbar from './components/navigation/Navbar'
import NoMatch from './pages/NoMatch'
import Loading from './components/Loading'
// import Error from './components/Error'
import ScrollToTop from './components/ScrollToTop'
import 'react-toastify/dist/ReactToastify.css'
import './styles/styles.scss'
import './styles/tailwind-main.scss'

const App = () => {
  const [state, setState] = useState(null)

  const authState = useSelector(state => state.auth)
  const apiState = useSelector(state => state.apiCalls)
  const gameState = useSelector(state => state.game)
  const studyGameState = useSelector(state => state.studyGame)
  const auth = useSelector(state => state.firebase.auth)
  const profile = useSelector(state => state.firebase.profile)
  const location = useLocation()
  const { width } = useWindowSize()

  useEffect(() => {
    if (isLoaded(auth) && isLoaded(profile)) {
      if (gameState.narrative || (studyGameState.currentRound <= studyGameState.rounds && studyGameState.currentRound !== 0)) {
        setState('main-container main-container-narrative')
      } else if (width > 768) {
        !isEmpty(auth) && isLoaded(profile) ? setState('main-container') : setState('main-container main-container-landpage')
      } else {
        setState('main-container main-container-landpage')
      }
    }
  }, [width, gameState.narrative, studyGameState.currentRound, studyGameState.rounds, auth, profile])

  return (
    <main className={state}>
      <ScrollToTop />
      {!isEmpty(auth) && <Navbar />}

      {apiState.isLoading || gameState.isLoading || studyGameState.isLoading || authState.isLoading ? <Loading /> :
        <>
          <Switch style={{ width: '100%', height: '100%' }} location={location}>
            {routes.map(({ path, name, isPrivate, Component }) => (
              isPrivate ?
                (<PrivateRoute key={name} exact path={path} component={Component} />)
                :
                (<Route key={name} exact path={path} component={Component} />)
            ))}
            <Route component={NoMatch} />
          </Switch>
        </>
      }

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </main>
  )
}

export default App